<template>
  <GlobalWindow
    :title="`配置${type.label}数据`"
    width="1000px"
    :visible.sync="visible"
    :with-footer="false"
  >
    <TableLayout class="field-type-data-table" v-permissions="['template:field:type:query']" :with-breadcrumb="false">
      <!-- 表格和分页 -->
      <template v-slot:table-wrap>
        <ul class="toolbar" v-permissions="['template:field:type:create', 'template:field:type:delete']">
          <li><el-button type="primary" @click="$refs.operaFieldTypeDataWindow.open(`新建${type.label}`, null, type)" icon="el-icon-plus" v-permissions="['template:field:type:create']">新建</el-button></li>
          <li><el-button @click="deleteByIdInBatch" icon="el-icon-delete" v-permissions="['template:field:type:delete']">删除</el-button></li>
        </ul>
        <el-table
          v-loading="isWorking.search"
          :data="tableData.list"
          stripe
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <!-- 图片 & 文本 & 数字 -->
          <el-table-column v-if="type.category === 'IMAGE' || type.category === 'TEXT' || type.category === 'NUMBER'" prop="value" label="数据值" min-width="150px">
            <template slot-scope="{ row }">
              <img v-if="type.category === 'IMAGE' && row.value !== '' && row.value != null" :src="row.value"/>
              <ColumnDetail v-if="type.category === 'TEXT' || type.category === 'NUMBER'" :content="row.value"/>
            </template>
          </el-table-column>
          <!-- 对象 -->
          <template v-else>
            <el-table-column v-for="field in fields" :prop="field.variable" :label="field.label" min-width="150px">
              <template slot-scope="{ row }">
                <img v-if="field.type === 'IMAGE' && row[field.variable] !== '' && row[field.variable] != null" :src="row[field.variable]"/>
                <ColumnDetail v-if="field.type === 'TEXT' || field.type === 'NUMBER'" :content="row[field.variable]"/>
              </template>
            </el-table-column>
          </template>
          <el-table-column prop="inputFrom" label="录入方式" min-width="100px">
            <template slot-scope="{ row }">{{row.inputFrom | inputFromText}}</template>
          </el-table-column>
          <el-table-column prop="createUserInfo.realname" label="创建人" min-width="100px"></el-table-column>
          <el-table-column prop="createTime" label="创建时间" min-width="140px"></el-table-column>
          <el-table-column prop="updateUserInfo.realname" label="更新人" min-width="100px"></el-table-column>
          <el-table-column prop="updateTime" label="更新时间" min-width="140px"></el-table-column>
          <el-table-column
            v-if="containPermissions(['template:field:type:update', 'template:field:type:delete'])"
            label="操作"
            min-width="120"
            fixed="right"
          >
            <template slot-scope="{row}">
              <el-button type="text" @click="$refs.operaFieldTypeDataWindow.open(`配置${type.label}`, row, type)" icon="el-icon-edit" v-permissions="['template:field:type:update']">编辑</el-button>
              <el-button type="text" @click="deleteById(row)" icon="el-icon-delete" v-permissions="['template:field:type:delete']">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <pagination
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
          :pagination="tableData.pagination"
        >
        </pagination>
      </template>
      <!-- 新建/修改 -->
      <OperaFieldTypeDataWindow :type="type" ref="operaFieldTypeDataWindow" @success="handlePageChange"/>
    </TableLayout>
  </GlobalWindow>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import OperaFieldTypeDataWindow from '@/components/template/OperaFieldTypeDataWindow'
import GlobalWindow from '../common/GlobalWindow'
import ColumnDetail from '../common/ColumnDetail'
export default {
  name: 'FieldTypeDataTableWindow',
  extends: BaseTable,
  components: { ColumnDetail, GlobalWindow, TableLayout, Pagination, OperaFieldTypeDataWindow },
  data () {
    return {
      visible: false,
      type: {},
      // 搜索
      searchForm: {
        typeId: null
      }
    }
  },
  computed: {
    fields () {
      if (this.type.fieldConfig != null && this.type.fieldConfig !== '') {
        return JSON.parse(this.type.fieldConfig)
      }
      return []
    }
  },
  methods: {
    open (target) {
      this.type = target
      this.searchForm.typeId = target.id
      this.visible = true
      this.search()
    },
    /**
     * 页码变更处理（分页时触发）
     *
     * @param pageIndex 新页码
     */
    handlePageChange (pageIndex) {
      this.tableData.pagination.pageIndex = pageIndex || this.tableData.pagination.pageIndex
      this.isWorking.search = true
      this.api.fetchList({
        page: this.tableData.pagination.pageIndex,
        capacity: this.tableData.pagination.pageSize,
        model: {
          typeId: this.type.id
        },
        sorts: this.tableData.sorts
      })
        .then(data => {
          this.tableData.list = data.records.map(row => {
            if (this.type.category === 'OBJECT') {
              const dynamicFieldConfig = JSON.parse(row.value)
              const dynamicFields = {}
              for (const key in dynamicFieldConfig) {
                dynamicFields[key] = dynamicFieldConfig[key]
              }
              return {
                ...row,
                ...dynamicFields
              }
            }
            return row
          })
          this.tableData.pagination.total = data.total
        })
        .catch(e => {
          this.$tip.apiFailed(e)
        })
        .finally(() => {
          this.isWorking.search = false
        })
    },
    /**
     * 删除（点击行操作/删除时触发）
     *
     * @param row 行对象
     * @param childConfirm 删除子节点时是否进行二次确认
     */
    deleteById (row, childConfirm = true) {
      this.__checkApi()
      const message = '确认删除该条数据吗?'
      this.$dialog.deleteConfirm(message)
        .then(() => {
          this.isWorking.delete = true
          this.api.deleteById(row[this.configData['field.id']])
            .then(() => {
              this.__afterDelete([row])
            })
            .catch(e => {
              this.$tip.apiFailed(e)
            })
            .finally(() => {
              this.isWorking.delete = false
            })
        })
        .catch(() => {})
    }
  },
  created () {
    this.config({
      module: '字段类型数据',
      api: '/template/fieldTypeData',
      'field.id': 'id',
      'field.main': 'id'
    })
  }
}
</script>
<style scoped lang="scss">
.field-type-data-table {
  /deep/ .table-content {
    padding: 0;
    .table-wrap {
      padding: 0;
    }
  }
  /deep/ .el-table__body {
    img {
      width: 80px;
      height: 80px;
      object-fit: contain;
    }
  }
}
</style>
